export default "__VITE_ASSET__DTYKxp3G__"